import serverVars from 'server-vars';
import thunk from 'redux-thunk';

/* Queries */
import { pdpRespRootQuery } from '../../queries/pdpRespRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespPreviewPageReducer as pdpPreviewPage } from '../../reducers/pdpRespPreviewPageReducer';
import { pdpRespPrintReducer as pdpPrint } from '../../reducers/pdpRespPrintReducer';
import { pdpRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/pdpRespNotificationsReducer';
import { pdpRespSimilarItemsReducer as similarItems } from '../../reducers/pdpRespSimilarItemsReducer';

/* Components */
import { PdpRespLayout } from '../../pdp/PdpRespLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { perfMeasureFromPageInit } from 'dibs-tracking/src/prometheus/peformanceTracking';
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

/* Actions */
import { setIsPdpRespPreviewPage } from '../../actions/pdpRespPreviewPageActions';

/* Notifications */
import { pdpRespNotifications } from '../../pdp/PdpRespNotifications/pdpRespNotifications';

import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout';
import { initSharedDatadogRum, pdpTypes } from 'dibs-buyer-layout/exports/initSharedDatadogRum';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';
import { pageDwellTracker, PAGE_DWELL_TRACKER_STOP_TIMES } from 'dibs-tracking';

const isPdpRespPreviewPage = serverVars.get('isPdpRespPreviewPage');

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    autoRunNotificationQueue: !isPdpRespPreviewPage,
    middleware: [thunk],
    notifications: pdpRespNotifications,
    reducers: {
        pdpPrint,
        pdpPreviewPage,
        sharedNotificationsReducer,
        similarItems,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

pageDwellTracker.start(PAGE_DWELL_TRACKER_STOP_TIMES.pdp.resp);

initSharedDatadogRum({ page: PAGE_TYPE.PDP, pageType: pdpTypes.marketplace, device: 'resp' });

initializeDBL(options).then(async ({ store }) => {
    perfMeasureFromPageInit({ subGroup: 'resp/init-dbl', monitoringGroup: 'unknown' });
    store.dispatch(setIsPdpRespPreviewPage({ isPdpRespPreviewPage }));
    createEntry({
        Container: PdpRespLayout,
        store,
        query: pdpRespRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
